import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getLocations } from '../../../../../redux/actions/countries'
import { getFilteredLanguages, getLanguages } from '../../../../../redux/actions/languages'
import { getRoles } from '../../../../../redux/actions/roles'
import { IRootState } from '../../../../../redux/types'

export function useInitialState() {
  const dispatch = useDispatch()

  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { provinces } = useSelector((state: IRootState) => state.country)
  const { languages } = useSelector((state: IRootState) => state.language)
  const { roles } = useSelector((state: IRootState) => state.role)

  useEffect(() => {
    if (roles.length === 0) dispatch(getRoles())
    if (provinces.length === 0) dispatch(getLocations())

    if (languages.length === 0) {
      if (authUser.role_id === 1) dispatch(getLanguages())
      else dispatch(getFilteredLanguages())
    }
  }, [])
}
